import { object, string } from 'yup'

import { dateOfBirthValidator } from './dateOfBirthValidator'
import {
  createImpossibleFieldErrorMessage,
  createMissingFieldErrorMessage,
  createYoungerThan17ErrorMessage,
} from './dateOfBirthValidator.utils'

export enum InputValidationError {
  RealDateError = 'realDateError',
  DateBefore1900Error = 'dateBefore1900Error',
  YoungerThan17 = 'youngerThan17',
}

export enum FieldValidationError {
  MissingFieldError = 'missingFieldError',
  InvalidInputValueError = 'invalidInputValueError',
  ImpossibleFieldValueError = 'impossibleFieldValueError',
}

const errorMessages: Record<
  InputValidationError | FieldValidationError,
  (value: string[]) => string
> = {
  [InputValidationError.RealDateError]: () => 'Please enter a valid date of birth',
  [InputValidationError.DateBefore1900Error]: () => 'Please enter a date of birth after 1900',
  [FieldValidationError.MissingFieldError]: createMissingFieldErrorMessage,
  [FieldValidationError.InvalidInputValueError]: () => 'Please enter a numeric value',
  [FieldValidationError.ImpossibleFieldValueError]: createImpossibleFieldErrorMessage,
  [InputValidationError.YoungerThan17]: createYoungerThan17ErrorMessage,
}

export const dateOfBirthSchema = object({
  day: string().nullable(),
  month: string().nullable(),
  year: string().nullable(),
})
  .required('Please enter your date the birth')
  .test({
    name: 'is-valid-dob',
    test: (dateObject, context) => {
      const res = dateOfBirthValidator(dateObject)

      if ('error' in res) {
        const createErrorMessage = errorMessages[res.error]
        const fieldsSuffix = res.fields?.join('-')
        const type = fieldsSuffix ? res.error + `-${fieldsSuffix}` : res.error

        return context.createError({
          message: createErrorMessage(res.fields || []),
          type,
        })
      }

      return true
    },
  })
